import { PropTypes } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Icon, Icons } from '@ge/components/icon';
import { CasePriority, TaskPriority } from '@ge/models/constants';

export const getSeverityColor = ({ level, theme }) => {
  switch (level?.toLowerCase()) {
    case TaskPriority.IMMEDIATE:
    case CasePriority.IMMEDIATE:
    case CasePriority.DOWN_TURBINE.toLowerCase():
    case TaskPriority.DOWN_TURBINE.toLowerCase():
      return theme.severity.immediateFillColor;
    case TaskPriority.HIGH:
    case CasePriority.HIGH:
    case TaskPriority.TIME_WINDOW_SHUTDOWN.toLowerCase():
    case CasePriority.TIME_WINDOW_SHUTDOWN.toLowerCase():
      return theme.severity.highFillColor;
    case TaskPriority.MEDIUM:
    case CasePriority.MEDIUM:
    case TaskPriority.NEXT_OPPORTUNITY_HIGH.toLowerCase():
    case CasePriority.NEXT_OPPORTUNITY_HIGH.toLowerCase():
      return theme.severity.mediumFillColor;
    case TaskPriority.LOW:
    case CasePriority.LOW:
    case TaskPriority.NEXT_OPPORTUNITY_LOW.toLowerCase():
    case CasePriority.NEXT_OPPORTUNITY_LOW.toLowerCase():
      return theme.severity.lowFillColor;
    case TaskPriority.TIME_WINDOW.toLowerCase():
    case CasePriority.TIME_WINDOW.toLowerCase():
      return theme.severity.sfTimeWindowFillColor;
    default:
      return theme.severity.defaultFillColor;
  }
};

const StyledSeverity = styled(Icon).attrs((props) => ({
  size: props.size,
  icon: Icons.SEVERITY,
  color: `${getSeverityColor(props)}!important`,
  viewbox: props.viewBox,
}))``;

export const Severity = ({ level, className, size, viewBox }) => (
  <StyledSeverity level={level} className={className} size={size} viewBox={viewBox} />
);

Severity.propTypes = {
  level: function (props, propName, componentName) {
    if (
      !props[propName] ||
      [
        'low',
        'medium',
        'high',
        'immediate',
        '1 Down Turbine',
        '2 Time Window Shutdown',
        '3 Time Window',
        '4 Next Opportunity High',
        '5 Next Opportunity Low',
      ].every((l) => l.toLowerCase() !== props[propName].toLowerCase())
    ) {
      return new Error(
        'Invalid prop `' +
          propName +
          '` supplied to' +
          ' `' +
          componentName +
          '`. Validation failed.',
      );
    }
  },
  className: PropTypes.string,
  size: PropTypes.number,
  viewBox: PropTypes.string,
};

Severity.defaultProps = {
  className: '',
  size: 8,
  viewBox: undefined,
};
